import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "position relative dorpwodn-container" }
const _hoisted_2 = { class: "cursor-pointer" }
const _hoisted_3 = { ref: "optionsContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", { handleClick: _ctx.handleClick })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white position absolute border rounded z-40 shadow-md overflow-hidden transitions-all duration-150 ease-in-out", [_ctx.align == 'left' ? 'left-0' : 'right-0']]),
      style: _normalizeStyle({
        top: '100%',
        width: _ctx.optionsWidth,
        opacity: _ctx.isOpen ? 1 : 0,
        height: _ctx.isOpen ? `${_ctx.contentHeight}px` : 0
      })
    }, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "options")
      ], 512)
    ], 6),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "w-screen h-screen z-30 fixed top-0 right-0 opacity-0",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}